<svg 
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.728027 7.88574C0.728027 4.01574 4.40918 0.885742 8.96063 0.885742C13.5121 0.885742 17.1932 4.01574 17.1932 7.88574C17.1932 13.1357 8.96063 20.8857 8.96063 20.8857C8.96063 20.8857 0.728027 13.1357 0.728027 7.88574ZM6.02041 7.88574C6.02041 9.26574 7.33763 10.3857 8.96063 10.3857C10.5836 10.3857 11.9008 9.26574 11.9008 7.88574C11.9008 6.50574 10.5836 5.38574 8.96063 5.38574C7.33763 5.38574 6.02041 6.50574 6.02041 7.88574Z" fill="#CAD1E1"/>
</svg>
